import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import * as fromRoot from '../stateManagement/rootReducer';
import { IApplicationState } from '../stateManagement/states/applicationState';

@Injectable()
export class NewRegisterUserGuard implements CanActivate {

    constructor(private router: Router, private store: Store<IApplicationState>) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
      //console.log('2.NewRegisterUserGuard');
      return this.guard();
    }

    private guard(): Observable<boolean> {
      return this.store.select(fromRoot.getAuthenticationIsNewRegisterUser)
        .map( (isNewUser: boolean) => {
          if (!isNewUser) {
            return true;
          } else {
            this.router.navigate(['/authentication/updatePassword']);
            return false;
          }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/newRegisterUser.guard.ts